import clsx from "clsx";

import { ResponseDetails } from "@smart/bridge-types-basic";
import { Icon } from "@smart/itops-sb-design-system-dom/src/components/icon";
import { Tooltip } from "@smart/itops-sb-design-system-dom/src/components/tooltip";

import { FieldItem, syncStatusColour, syncStatusLabel } from "../../../types";
import { Label } from "../label";

export const AppointmentFieldWrapper = ({
  children,
  id,
  error,
  errorId,
  field,
  responseDetails,
}: {
  children: React.ReactNode;
  id: string;
  error?: string;
  errorId: string;
  field: FieldItem;
  responseDetails?: ResponseDetails;
}) => (
  <div
    className="rounded-[var(--input-brand-radius,0.8rem)] border border-neutral-100 print:break-inside-avoid"
    id={id}
    aria-invalid={!!error}
    aria-errormessage={error ? errorId : undefined}
    data-testid={`appointment-field-wrapper-${field.uri}`}
  >
    <div className="px-[2.4rem] border-b border-neutral-100">
      <div className="flex gap-small items-center w-fit py-[1.6rem] border-b-2 border-neutral-500">
        <Label {...field} />
        {responseDetails && (
          <div className="flex items-center gap-small">
            {responseDetails?.syncStatus && (
              <Tooltip
                text={syncStatusLabel[responseDetails?.syncStatus || "unknown"]}
                offsetBy={6}
              >
                <Icon
                  name="solidCircleInfo"
                  className={clsx(
                    "flex items-center",
                    syncStatusColour[responseDetails?.syncStatus || "unknown"],
                  )}
                />
              </Tooltip>
            )}
          </div>
        )}
      </div>
    </div>
    {children}
  </div>
);
